/**
 * Subscription Service (Architecture Stub)
 * 
 * [FUTURE EXTENSIBILITY]
 * This service acts as the Interface between the UI (WalletTab) and the Payment Provider (Toss Billing).
 * When implementing Phase 5 (Subscriptions):
 * 1. Replace the 'alert' in `requestUpgrade` with `TossPayments.requestBillingAuth(...)`
 * 2. Handle the server callback in Cloud Functions.
 * 
 * The UI code will NEVER need to change.
 */
import { locale } from "./LocaleService.js";

// [CONFIG PLACEHOLDER]
// Paste your Toss Client Key here when ready.
const BILLING_CONFIG = {
    clientKey: 'TEST_CK_D5GePWvyJnrK0W0k6q8gLzN97Eoq', // Example Key
    successUrl: `${window.location.origin}/subscription/success`,
    failUrl: `${window.location.origin}/subscription/fail`
};

export const SubscriptionService = {
    /**
     * Request a Subscription Upgrade
     * @param {string} tierId - 'premium_monthly' | 'premium_yearly'
     */
    requestUpgrade: async (tierId) => {
        console.log(`[SubscriptionService] Requesting upgrade to ${tierId}`);
        const user = window.user;

        if (!user) {
            window.Modal.alert(locale.t('auth.login_required'));
            return;
        }

        // [PROD CODE TEMPLATE]
        // Uncomment below to activate Toss Payments Billing
        /*
        try {
            const toss = await loadTossPayments(BILLING_CONFIG.clientKey);
            await toss.requestBillingAuth('카드', {
                customerKey: user.uid,
                successUrl: BILLING_CONFIG.successUrl,
                failUrl: BILLING_CONFIG.failUrl
            });
        } catch (error) {
            console.error("Billing Auth Failed", error);
            alert("결제 인증에 실패했습니다.");
        }
        */

        // Current Placeholder (Demo Mode)
        await window.Modal.alert(
            "🚀 [Module Hook Verified]\n\n" +
            "구독제 모듈이 이곳에 연동됩니다.\n" +
            "UI 수정 없이 'SubscriptionService' 내부 로직만 교체하면\n" +
            "즉시 정기 결제가 시작됩니다.\n\n" +
            "(Hybrid Model: 충전소와 구독제 동시 운영 가능)"
        );
    },

    /**
     * Manage existing subscription (Cancel/Pause)
     */
    manageSubscription: async () => {
        // Future: Open management portal or simplified cancel modal
        alert("Subscription Management Module");
    }
};

// Helper Loading Logic (Optional)
async function loadTossPayments(key) {
    if (!window.TossPayments) {
        // Dynamic Script Load if missing
        await new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://js.tosspayments.com/v1";
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    return window.TossPayments(key);
}
